module.exports = __webpack_public_path__ + "static/media/ClubsportIcon.3320ee1a.svg";